var EHDI = EHDI || Object.create(null);

EHDI.CollisionManager = Object.create(null);

EHDI.CollisionManager.testRectCollision = function (hitbox1, hitbox2) {

  var vectorX = hitbox1._updatedCenterX - hitbox2._updatedCenterX;
  var vectorY = hitbox1._updatedCenterY - hitbox2._updatedCenterY;

  var combinedHalfWidths = hitbox1._halfWidth + hitbox2._halfWidth;
  var combinedHalfHeights = hitbox1._halfHeight + hitbox2._halfHeight;

  var collided = false;

  if (Math.abs(vectorX) < combinedHalfWidths) {
    if (Math.abs(vectorY) < combinedHalfHeights) {
      collided = true;
    }
  }

  return collided;
};

EHDI.CollisionManager.testRectVerticalCollision = function (hitbox1, hitbox2) {

  var vectorX = hitbox1._updatedCenterX - hitbox2._updatedCenterX;

  var combinedHalfWidths = hitbox1._halfWidth + hitbox2._halfWidth;

  var collided = false;

  if (Math.abs(vectorX) < combinedHalfWidths) {
    collided = true;
  }

  return collided;
};
